import { render, staticRenderFns } from "./PaginationGoto.vue?vue&type=template&id=ffc7277e&"
import script from "./PaginationGoto.vue?vue&type=script&lang=js&"
export * from "./PaginationGoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports